module.exports = __webpack_public_path__ + "img/event-view-002.b3f1b027.jpg";